import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../config/api";
import { getCorporateLoginSectionDataPending, getCorporateLoginSectionDataSuccess, getCorporateLoginSectionDataFailure, corporateSingupDataPending, corporateSingupDataSuccess, corporateSingupDataFailure, getAgencyLoginSectionDataPending, getAgencyLoginSectionDataSuccess, getAgencyLoginSectionDataFailure } from "../slice/corporateLoginSlice";
// import axios from "axios";

import { config } from "../../../../src/config/global";
// import { tr } from "date-fns/locale";

const Login_URL = config.CORPORATE_BOOKING_SIGNIN;
const SingU_p_URL = config.CORPORATE_BOOKING_SIGNUP;
const fetchCorporateLoginData = async loginPayload => {
  const data = {
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json"
    },
    loader: true
  };
  const loginPayloadData = {
    username: loginPayload.accountId,
    password: loginPayload.password,
    userType: loginPayload.userType
  };
  const response = await api.post(Login_URL, loginPayloadData, data);
  return response;
};
function* getCorporateLoginData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchCorporateLoginData, payload);
    localStorage.setItem("corporateToken", response?.data?.token);
    localStorage.setItem("corporateFirstname", response?.data?.firstname);
    localStorage.setItem("corporateLastname", response?.data?.lastname);
    localStorage.setItem("corporateModules", response?.data?.modules);
    localStorage.setItem("corpName", response?.data?.corpAgencyName);
    localStorage.setItem("corporateafterLogin", "true");
    localStorage.setItem("expireTime", response?.data?.tokenExpiryUTC);
    yield put(getCorporateLoginSectionDataSuccess(response?.data));
  } catch (error) {
    yield put(getCorporateLoginSectionDataFailure(error));
  }
}
const fetchAgencyLoginData = async loginPayload => {
  const data = {
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json",
      accessToken: `${sessionStorage.getItem("temptoken")}`,
      "Access-Control-Expose-Headers": "Authorization"
    },
    loader: true
  };
  const loginPayloadData = {
    username: loginPayload.accountId,
    password: loginPayload.password,
    userType: loginPayload.userType
  };
  const response = await api.post(Login_URL, loginPayloadData, data);
  return response;
};
const fetchCorporateSingupData = async singUpPayload => {
  const data = {
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json"
    },
    loader: true
  };
  const response = await api.post(SingU_p_URL, singUpPayload, data);
  return response;
};
function* getAgencyLoginData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchAgencyLoginData, payload);
    localStorage.setItem("agencyToken", response?.data?.token);
    localStorage.setItem("agencyFirstname", response?.data?.firstname);
    localStorage.setItem("agencyLastname", response?.data?.lastname);
    localStorage.setItem("agencyModules", response?.data?.modules);
    localStorage.setItem("corpAgencyName", response?.data?.corpAgencyName);
    localStorage.setItem("agencyafterLogin", "true");
    localStorage.setItem("expireTime", response?.data?.tokenExpiryUTC);
    localStorage.setItem("corporateAgencyName", response?.data?.corpAgencyName);
    yield put(getAgencyLoginSectionDataSuccess(response?.data));
  } catch (error) {
    yield put(getAgencyLoginSectionDataFailure(error));
  }
}
export function* watchCorporateLoginData() {
  yield takeLatest(getCorporateLoginSectionDataPending.type, getCorporateLoginData);
}
function* getCorporateDetails(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchCorporateSingupData, payload);
    yield put(corporateSingupDataSuccess(response?.data));
  } catch (error) {
    yield put(corporateSingupDataFailure(error));
  }
}
export function* watchAgencyLoginData() {
  yield takeLatest(getAgencyLoginSectionDataPending.type, getAgencyLoginData);
}
export function* watchCorporateSignupDetails() {
  yield takeLatest(corporateSingupDataPending.type, getCorporateDetails);
}